export default __webpack_public_path__ + "static/media/bw-avatar.182b9ce8.svg";